import { NavLink } from "react-router-dom";

export const SettingsSidebar = () => {
  const menuItems = [
    { to: "/settings/roles", label: "Roles & Permissions" },
    { to: "/settings/integrations", label: "Integrations" },
    { to: "/settings/system", label: "System Controls" },
    { to: "/settings/audit", label: "Audit Logs" },
    { to: "/settings/policies", label: "App Policies" },
  ];

  return (
    <div className="w-64 bg-[#191919] border-r-2 border-dark-20 p-6">
      <h1 className="text-2xl font-semibold mb-8 text-white">Settings</h1>
      <nav className="space-y-1">
        {menuItems.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-2 p-2 rounded-[5px] hover:bg-dark-20 ${
                isActive
                  ? "bg-dark-20 font-medium text-white"
                  : "text-[#606060]"
              }`
            }
          >
            <p className="text-sm">{label}</p>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
